import React, {RefObject} from "react";
import StepsTitleBar from "../../shared/steps/StepsTitleBar";
import StepsManager from "../../shared/steps/StepsManager";
import {InputMethodStep} from "./InputMethodStep";
import {WaterSystemStep} from "./WaterSystemStep";
import {TankSelectionStep} from "./TankSelectionStep";
import {SummaryStep} from "./SummaryStep";
import {default as StepComponent} from "../../configuration/steps/Step";
import StepModel from "../../../model/configurator/StepModel";
import StepNavigationButtons from "../../shared/steps/StepNavigationButtons";
import formModelStore from "../../../store/FormModelStore";
import {Step} from "../../common/Interfaces";
import TWSProjectCalculationPageHeader from "@lib/components/tws-project/calculation/TWSProjectCalculationPageHeader";
import store from "@lib/store/configuration";
import TWSCalculationApiService from "@lib/api-services/TWSCalculationApiService";
import APIServicesRegistry from "@lib/api-services/APIServicesRegistry";
import flattenConfigurationModel from "@lib/flattenConfigurationModel";
import {EditorType} from "../../shared/steps/BaseStep";


interface SelfState {
    currentStepIndex: number,
    currentStepId: string,
    stepsManager: StepsManager,
    steps: Step[],
    canProceed: boolean,
    justBeenSaved: boolean
}

interface StepObject {
    stepSlug: string,
    component: StepComponent,
    ref: React.RefObject<unknown>
}

export enum StepsSlugs {
    InputMethod = "inputMethod",
    WaterSystem = "waterSystem",
    TankSelection = "tankSelection",
    Summary = "summary",
}

export class TWSProjectCalculationContainer extends React.Component<any> {
    stepAreaRef: RefObject<any> = React.createRef()
    stepsObjects: StepObject[] = [];
    _tWSCalculationApiService: TWSCalculationApiService | null = null;
    state: SelfState = {
        currentStepIndex: 0,
        currentStepId: StepsSlugs.InputMethod,
        stepsManager: new StepsManager(),
        justBeenSaved: true,
        steps: [
            {isValid: true, name: __("Input method"), slug: StepsSlugs.InputMethod, canProceedHere: true, available: true},
            {isValid: true, name: __("Tap water system"), slug: StepsSlugs.WaterSystem, canProceedHere: this.props.id.value > 0, available: true},
            {isValid: true, name: __("Tank selection"), slug: StepsSlugs.TankSelection, canProceedHere: this.props.id.value > 0, available: false},
            {isValid: true, name: __("Summary"), slug: StepsSlugs.Summary, canProceedHere: this.props.id.value > 0, available: true}
        ],
        canProceed: false,
    }


    constructor(props: any) {
        super(props);
        this.addStep(StepsSlugs.InputMethod, InputMethodStep)
        this.addStep(StepsSlugs.WaterSystem, WaterSystemStep)
        this.addStep(StepsSlugs.TankSelection, TankSelectionStep)
        this.addStep(StepsSlugs.Summary, SummaryStep)

        this.stepsObjects.forEach((stepObject: StepObject) => {
            let componentStepModel = (stepObject.component as unknown as typeof StepComponent).getStepModel({})
            this.state.stepsManager.addStepModel(componentStepModel?.name, componentStepModel ?? new StepModel())
        })

        if (this.props.id.value > 0) {
            this.state.justBeenSaved = true;
        }
        console.warn('init data', this.props)
        formModelStore.setFormModel(this.props);

        window.scheduleAtDocumentReady(() => {
            this._tWSCalculationApiService = APIServicesRegistry.getService(TWSCalculationApiService)
            if (this.props.id.value > 0) {
                window.setTimeout(() => {
                    this.moveThroughStepTimeline(this.state.steps.filter(s => s.available).length - 1);
                }, 250)
            } else {
                this.moveThroughStepTimeline(0);
            }
        })

        window.onbeforeunload = e => {
            e = e || window.event;

            if (store.dirty) {
                const message = __('Changes that you have made will not be saved.');

                if (e) {
                    e.returnValue = message;
                }

                return message;
            }
        }

    }

    addStep = (stepSlug: string, component: any) => {
        this.stepsObjects.push({stepSlug, component, ref: React.createRef()})
    }

    renderHeader() {
        return <TWSProjectCalculationPageHeader
            calculationName={this.props.name.value}
            saveCalculation={this.saveCalculation}
            hasDocumentationPermission={this.props.hasDocumentationPermission}
            showPrintButton={this.showPrintButton()}
            showSaveButton={this.showSaveButton()}
            calculationId={this.props.id}
            project={{id: this.props.projectId, number: this.props.projectNumber}}/>
    }

    moveThroughStepTimeline = (stepAmount: number) => {
        // Step index out of bounds.
        if (this.state.currentStepIndex + stepAmount > this.state.steps.filter(s => s.available).length ||
            this.state.currentStepIndex + stepAmount < 0) {
            return;
        }
        let targetStep = this.stepsObjects.find(x => x.stepSlug === this.state.steps.filter(s => s.available)[this.state.currentStepIndex + stepAmount].slug)

        this.setState({
            currentStepIndex: this.state.currentStepIndex + stepAmount,
            currentStepId: targetStep?.stepSlug
        })
    }

    onFormModelChange = () => {
        console.warn('formModelStore', formModelStore)
    }

    onNextStepButtonClick = () => {
        this.moveThroughStepTimeline(+1);
    }

    renderSteps = () => {
        return (<div className={`row row-no-gutter`}>
            <div className="basic-step-area-container" ref={this.stepAreaRef}>
                {this.state.steps.filter(s => s.available).map((step: any, index) => this.renderStep(step, index === this.state.currentStepIndex))}
            </div>
        </div>);
    }

    showPrintButton = (): boolean => {
        return this.state.justBeenSaved && (this.state.steps.find(s => s.slug == StepsSlugs.Summary)?.canProceedHere ?? false);
    }

    showSaveButton = (): boolean => {
        return this.state.steps.find(s => s.slug == StepsSlugs.Summary)?.canProceedHere ?? false;
    }

    render() {
        return (
            <React.Fragment>
                <div className={`page-with-steps-container`}>
                    {this.renderHeader()}
                    <StepsTitleBar {...this.state} moveThroughStepTimeline={this.moveThroughStepTimeline}/>
                    {this.renderSteps()}
                    <StepNavigationButtons activeAvailableSteps={this.state.steps.filter(s => s.available)}
                                           currentStepIndex={this.state.currentStepIndex}
                                           currentStep={this.state.currentStepId}
                                           onNextStepButtonClick={this.onNextStepButtonClick}
                                           nextButtonAvailable={this.state.canProceed}
                                           onPreviousStepButtonClick={() => {
                                               this.moveThroughStepTimeline(-1)
                                           }}
                    />
                </div>
            </React.Fragment>
        )
    }

    stepChangeCallback = (stepSlug: string, canProceed: boolean) => {
        let stepIndex = this.state.steps.findIndex(s => s.slug === stepSlug);
        if (stepIndex > -1) {
            this.setState({canProceed: canProceed});
        }
    }

    //Needs to set active step changer in header
    setLastAvailableStep = (stepSlug: string) => {
        let stepIndex = this.state.steps.findIndex(s => s.slug === stepSlug);
        if (stepIndex > -1) {
            let steps = this.state.steps;
            for (let i = 0; i < steps.length; i++) {
                steps[i].canProceedHere = i <= stepIndex;
            }
            this.setState({steps: steps});
        }
    }

    private updateStepAvailability = (step: StepsSlugs, available: boolean) => {
        let steps = this.state.steps;
        let stepObject = steps.findIndex(s => s.slug === step);
        steps[stepObject].available = available;
        this.setState({steps: steps});
    }

    private setDirty = () => {
        this.setState({justBeenSaved: false})
    }

    private renderStep(step: any, visibleStep: boolean) {
        step = this.stepsObjects.find(x => x.stepSlug === step.slug)
        let StepComponent = step.component

        return (
            <div key={step.stepSlug} className={`configuration-editor-step-${step.stepSlug.toLowerCase()}`}
                 style={{display: visibleStep ? 'initial' : 'none'}}>
                <StepComponent ref={step.ref}
                               onFormModelChange={this.onFormModelChange}
                               visible={visibleStep}
                               stepChangeCallback={this.stepChangeCallback}
                               setLastAvailableStep={this.setLastAvailableStep}
                               updateStepAvailability={this.updateStepAvailability}
                               stepSlug={step.stepSlug}
                               stepsManager={this.state.stepsManager}
                               editMode={this.props.id.value > 0}
                               editorType={EditorType.Responsible}
                               model={formModelStore.formModel}
                               setDirty={this.setDirty}
                />
            </div>
        )
    }

    saveCalculation = () => {
        this._tWSCalculationApiService?.saveCalculation(flattenConfigurationModel(formModelStore).formModel)
            .then(response => {
                this.setState({justBeenSaved: true})
            })
    }
}

window.components.TWSProjectCalculationContainer = TWSProjectCalculationContainer;